export default import.meta.env.PROD
  ? 'live' /** used for live deployment */
  : 'dev' /** used for staging deployment and development */;
